/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StorageAccountResponse } from './StorageAccountResponse';
import {
    StorageAccountResponseFromJSON,
    StorageAccountResponseFromJSONTyped,
    StorageAccountResponseToJSON,
    StorageAccountResponseToJSONTyped,
} from './StorageAccountResponse';

/**
 * 
 * @export
 * @interface StorageAccountValidationResult
 */
export interface StorageAccountValidationResult {
    /**
     * 
     * @type {boolean}
     * @memberof StorageAccountValidationResult
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountValidationResult
     */
    status?: StorageAccountValidationResultStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof StorageAccountValidationResult
     */
    validatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof StorageAccountValidationResult
     */
    message?: string;
    /**
     * 
     * @type {StorageAccountResponse}
     * @memberof StorageAccountValidationResult
     */
    account?: StorageAccountResponse;
}


/**
 * @export
 */
export const StorageAccountValidationResultStatusEnum = {
    PendingValidation: 'PENDING_VALIDATION',
    Active: 'ACTIVE',
    ValidationFailed: 'VALIDATION_FAILED',
    Disabled: 'DISABLED'
} as const;
export type StorageAccountValidationResultStatusEnum = typeof StorageAccountValidationResultStatusEnum[keyof typeof StorageAccountValidationResultStatusEnum];


/**
 * Check if a given object implements the StorageAccountValidationResult interface.
 */
export function instanceOfStorageAccountValidationResult(value: object): value is StorageAccountValidationResult {
    return true;
}

export function StorageAccountValidationResultFromJSON(json: any): StorageAccountValidationResult {
    return StorageAccountValidationResultFromJSONTyped(json, false);
}

export function StorageAccountValidationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageAccountValidationResult {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'status': json['status'] == null ? undefined : json['status'],
        'validatedAt': json['validatedAt'] == null ? undefined : (new Date(json['validatedAt'])),
        'message': json['message'] == null ? undefined : json['message'],
        'account': json['account'] == null ? undefined : StorageAccountResponseFromJSON(json['account']),
    };
}

export function StorageAccountValidationResultToJSON(json: any): StorageAccountValidationResult {
    return StorageAccountValidationResultToJSONTyped(json, false);
}

export function StorageAccountValidationResultToJSONTyped(value?: StorageAccountValidationResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'status': value['status'],
        'validatedAt': value['validatedAt'] == null ? undefined : ((value['validatedAt']).toISOString()),
        'message': value['message'],
        'account': StorageAccountResponseToJSON(value['account']),
    };
}

